import DataBase from "./data_base";
import GraphContainer, { getOrSetVec, getOrSet } from "../graph_container";

class DataGraph extends DataBase {
    constructor(graphing) {
        super(graphing);

        this._func = ({ x, m, b }) => m * x + b;
        this._params = { m: 1, b: 0 };

        this._path = GraphContainer.create("path");
        this.append(this._path);

        this._width = 2.5;
        this._range = new THREE.Vector2(-Infinity, Infinity);
        this._d = "";
        this._customDomain = false;
    }

    _serialize() {
        return {
            width: this._width,
            func: this._func.toString(),
            range: this._range.toArray(),
            params: Object.assign({}, this._params),
            customDomain: this._customDomain
        };
    }

    get type() { return "graph"; }
    get defaultName() { return "Graph"; }

    /**
     * @returns {this}
     */
    width() { return getOrSet.call(this, this, "_width", ...arguments); }

    /**
     * @returns {this}
     */
    customDomain() { return getOrSet.call(this, this, "_customDomain", ...arguments); }

    /**
     * @returns {this}
     */
    path() { return getOrSet.call(this, this, "_d", ...arguments); }

    /**
     * @returns {this}
     */
    func() { return getOrSet.call(this, this, "_func", ...arguments); }

    /**
     * @returns {this}
     */
    params() { return getOrSet.call(this, this, "_params", ...arguments); }

    /**
     * @returns {this}
     */
    range() { return getOrSetVec.call(this, "_range", ...arguments); }

    redraw() {
        this._path
            .setAttribute("stroke", this._color)
            .setAttribute("fill", "none")
            .setAttribute("stroke-width", this._width)
            .setAttribute("stroke-linecap", "round")
            .setAttribute("d", this._d);

        return this;
    }

    static deserialize(graphing, data) {
        const g = new DataGraph(graphing, data).deserialize(data);
        let fun_lambda;

        g._width = "width" in data ? data.width : g._width;
        g._func = "func" in data ? eval("fun_lambda=" + data.func) : g._func;
        g._params = "params" in data ? data.params : g._params;
        g._customDomain = "customDomain" in data ? data.customDomain : g._customDomain;

        if ("range" in data) {
            g._range.setX(Number.isFinite(data.range[0]) ? data.range[0] : -Infinity)
            g._range.setY(Number.isFinite(data.range[1]) ? data.range[1] : Infinity)
        }

        return g;
    }
}

export default DataGraph;
export { DataGraph };